import './CSS_ke_log/CssForFIVEJS.css'
const SanitiMatra = () => {

return(
<p id="pncilwala">अपने हाथों की सभी सतहों को ढकने के लिए मुट्ठी भर अल्कोहल-आधारित सैनिटाइज़र लगाएं। अपने हाथों को सही तकनीक का उपयोग करके तब तक रगड़ें जब तक कि वे सूख न जाएं। पूरी प्रक्रिया 20-30 सेकंड तक चलनी चाहिए।</p>

);


}
export default SanitiMatra;

